<template>
  <div style="max-width: 600px; height: 100vh" class="mx-auto bg-white">
    <div
      class="d-flex align-items-center flex-column justify-content-center my-1"
    >
      <b-img
        class="mx-auto"
        style="height: 100px"
        :src="require('@/assets/images/logo/header-logo.png')"
      />
      <b-button @click="$router.go(-1)" variant="info">
        <feather-icon size="16" icon="ArrowLeftIcon" class="mr-50" />
        عودة
      </b-button>
    </div>
    <FileViewer class="w-100" style="height: 80%" :fileEp="$route.query.ep" />
  </div>
</template>

<script>
import { BImg, BButton } from "bootstrap-vue";
import FileViewer from "@/components/file-viewer";
export default {
  components: { FileViewer, BImg, BButton },
};
</script>
